// extracted by mini-css-extract-plugin
export default {"Benefits":"Benefits_Benefits__B-pan","Benefits__benefitDetail":"Benefits_Benefits__benefitDetail__MW0yV"};